import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as IconFacebook } from '../../media/icons/social_facebook.svg';
import { ReactComponent as IconInstagram } from '../../media/icons/social_instagram.svg';
import { ReactComponent as IconLinkedin } from '../../media/icons/social_linkedin.svg';

export default class Footer extends Component {
    render() {
        return (
            <div className="footer">
                <div className="footer__background">
                    <div className="footer__background__top"></div>
                    <div className="footer__background__top-overlay"></div>
                </div>
                <div className="footer-wrapper">

                    <div className="footer__column">
                        <div className="footer__column__element footer__column__title text-bold text-subtitle">
                            About
                        </div>
                        <div className="footer__column__element text-box text-justify">
                            Guidr helps travelers discover and plan unforgettable trips with expert-curated itineraries. Whether you're looking for hidden gems, adventure-packed journeys, or foodie escapes, find the perfect itinerary crafted by locals and travel experts. Start exploring today!
                        </div>
                        <div className="footer__column__element text-box text-justify">
                            We enable travel creators to share their expertise by creating and selling itineraries on our platform. Whether you're a local guide, travel blogger, or industry expert, join our community and turn your travel knowledge into income. 
                        </div>
                    </div>

                    <div className="footer__column">
                        <div className="footer__column__element footer__column__title text-bold text-subtitle">
                            Explore locations
                        </div>
                        <div className="footer__column__element">
                            <Link to="/trips?category=Beach" className="link-color-light">
                                Sunny beach trips
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/trips?size=Couple" className="link-color-light">
                                Romantic couple trips
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/trips?category=Roadtrip" className="link-color-light">
                                Relaxing roadtrips
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/trips?category=Nature" className="link-color-light">
                                Nature escapes
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/trips?category=City%20trip" className="link-color-light">
                                Historic city trips
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/trips?category=Party" className="link-color-light">
                                Glamorous party trips
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/trips?category=Cultural" className="link-color-light">
                                Authentic cultural experiences
                            </Link>
                        </div>
                    </div>

                    <div className="footer__column">
                        <div className="footer__column__element footer__column__title text-bold text-subtitle">
                            Learn more
                        </div>
                        <div className="footer__column__element">
                            <Link to="/travelers" className="link-color-light">
                                For travelers and trip planners
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/creators" className="link-color-light">
                                For travel creators
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/hosts" className="link-color-light">
                                For hotels & Airbnb hosts
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/tourismagencies" className="link-color-light">
                                For tourism agencies
                            </Link>
                        </div>
                        
                        <div className="footer__column__element">
                            <Link to="/feedback" className="link-color-light">
                                Share your feedback
                            </Link>
                        </div>
                        {/* <div className="footer__column__element">
                            <Link to="/ambassador" className="link-color-light">
                                Become an ambassador
                            </Link>
                        </div> */}
                        <div className="footer__column__element">
                            <Link to="/contact" className="link-color-light">
                                Contact us
                            </Link>
                        </div>

                        <div className="footer__column__element">
                            <Link to="/privacy" className="link-color-light">
                                Privacy policy
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/terms" className="link-color-light">
                                Terms of use
                            </Link>
                        </div>

                        <div className="footer__column__element">
                            <Link to="/signup" className="link-color-light">
                                Sign up
                            </Link>
                        </div>
                        <div className="footer__column__element">
                            <Link to="/login" className="link-color-light">
                                Log in
                            </Link>
                        </div>

                    </div>

                    <div className="footer__column footer__column--wide">
                        <div className="footer__column__element">
                            <div className="footer__social-container">
                                <Link to={"https://www.instagram.com/guidrtrips/"} className="footer__social__logo">
                                    <IconInstagram className="footer__social__logo-inner" />
                                </Link>
                                <Link to={"https://www.linkedin.com/company/guidrtrips"} className="footer__social__logo">
                                    <IconLinkedin className="footer__social__logo-inner" />
                                </Link>
                                {/* <Link to={""} className="footer__social__logo">
                                    <IconFacebook className="footer__social__logo-inner" />
                                </Link> */}
                            </div>
                        </div>
                        <div className="footer__column__element">
                            <div className="footer__copyright">
                                © 2026 Guidr. All rights reserved worldwide.
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}
